import { _GameNameNormalBase } from './gameNameNormalBase'

export class _GameNameNormalDefault extends _GameNameNormalBase {
  cssType: 'default' = 'default'
  protected initPC(): this {
    this['--game-name-font-size'] = '0.2rem'
    return this
  }
  protected initH5(): this {
    this['--game-name-font-size'] = '0.24rem'
    return this
  }
}
